export default class Course {
    constructor() {
        this._id = null;
        this._subject = null;
        this._code = null;
        this._name = null;
        this._timetables = [];
        this._timetableIDS = [];
        this._tutors = [];
        this._tutorIDs = [];
        this._type = null;
    }
    get tutorIDs() {
        return this._tutorIDs;
    }
    set tutorIDs(value) {
        this._tutorIDs = value;
    }
    get timetableIDS() {
        return this._timetableIDS;
    }
    set timetableIDS(value) {
        this._timetableIDS = value;
    }
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    get subject() {
        return this._subject;
    }
    set subject(value) {
        this._subject = value;
    }
    get code() {
        return this._code;
    }
    set code(value) {
        this._code = value;
    }
    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }
    get timetables() {
        return this._timetables;
    }
    set timetables(value) {
        this._timetables = value;
    }
    get tutors() {
        return this._tutors;
    }
    set tutors(value) {
        this._tutors = value;
    }
    get type() {
        return this._type;
    }
    set type(value) {
        this._type = value;
    }
}
